import { guid } from '@/mixins/guid';

export function linkShape() {
  return () => ({
    _id: guid.methods.guid(),
    title: 'Link',
    pageLink: false,
    customLink: false,
    subLinks: [],
    type: 'droplet.navigation.editorLinks',
  });
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/navigation/utils.js